import { useState } from 'react';
import { Pagination } from '@tryhackme/thm-ui-components';
import { BadgesProps } from 'src/features/public-profile/components/badges-tab/badges.types';
import { StyledBadges } from 'src/features/public-profile/components/badges-tab/badges.styles';
import { Badge } from 'src/features/badges/components/badge';
import { BadgeItem } from 'src/common/interfaces';
import { StyledLoadingPagination, StyledLoading, StyledNoItemsText, StyledTabPaper } from 'src/features/public-profile/public-profile.styles';
import { useGetBadges } from 'src/features/public-profile/hooks';
export const BadgesTab = ({
  userId
}: BadgesProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const {
    badges,
    isLoading,
    totalBadges = 0,
    totalPages = 0,
    refetch
  } = useGetBadges(userId, currentPage);
  const handlePageChange = async (pageNumber: number) => {
    setCurrentPage(pageNumber);
    await refetch();
  };
  if (isLoading) {
    return <StyledTabPaper withoutBg data-testid="loading">
        <StyledLoading />
        <StyledLoadingPagination>
          <StyledLoading width="24.4rem" height="3.6rem" />
          <StyledLoading width="30rem" height="1.4rem" />
        </StyledLoadingPagination>
      </StyledTabPaper>;
  }
  if (!totalBadges) {
    return <StyledTabPaper>
        <StyledNoItemsText>This user has not earned any badges yet.</StyledNoItemsText>
      </StyledTabPaper>;
  }
  return <StyledTabPaper withoutBg data-sentry-element="StyledTabPaper" data-sentry-component="BadgesTab" data-sentry-source-file="badges-tab.tsx">
      {badges && <>
          <StyledBadges>
            {badges.map((badge: BadgeItem) => <Badge badge={badge} key={badge.title} />)}
          </StyledBadges>
          {totalPages > 1 &&
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      <Pagination totalPages={totalPages} selectedPage={currentPage} onChange={handlePageChange} />}
        </>}
    </StyledTabPaper>;
};